import React from 'react';
import { StarIcon } from 'lucide-react';
const coaches = [{
  name: 'Sofía M.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1ac64876-b8e0-4ff8-b2d7-2402614456a3.jpg'
}, {
  name: 'Carolina R.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d0dfb67d-e766-4580-9d5a-88b718b2d280.jpg'
}, {
  name: 'Valentina F.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2a6b2bd8-db9d-4155-ba01-da6fdc88897b.jpg'
}, {
  name: 'Luciana P.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6d8ba606-6f4b-458e-98bb-38df239911ab.jpg'
}, {
  name: 'Marcela G.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/028d1cac-2873-487f-af73-d8cc6af8ea37.jpg'
}];
export function SocialProofBar() {
  return <section className="bg-[#06171c] border-y border-brand-accent/15" data-id="element-307" data-mp="1i39pms8uwsa2">
      <div className="max-w-5xl mx-auto px-4 py-5 md:py-6 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-308" data-mp="1i4koqercxbuu">
        <div className="flex -space-x-2.5" aria-label="Entrenadoras que ya usan Stretching 360" data-id="element-309" data-mp="18ob3ce1cs6zp">
          {coaches.map(coach => <img key={coach.name} src={coach.image} alt={`Foto de perfil de ${coach.name}, profe de Stretching`} className="w-11 h-11 rounded-full object-cover border-2 border-[#06171c] shadow-md" data-id="element-310" data-mp="1dmcp56q5ykev" />)}
        </div>
        <div className="flex flex-col items-center sm:items-start" data-id="element-311" data-mp="pxl552mq98d6">
          <div className="flex items-center gap-2" data-id="element-312" data-mp="uojne7ra0gj2">
            <div className="flex text-amber-400" aria-label="Calificación 4.9 de 5" data-id="element-313" data-mp="uq4fzru15pea">
              {[...Array(5)].map((_, index) => <StarIcon key={index} className="w-4 h-4 fill-current" data-id="element-314" data-mp="gv22aiixyvqx" data-mpi={index} />)}
            </div>
            <span className="text-white font-display font-black text-lg" data-id="element-315" data-mp="kyzzgnophwhc">4.9/5</span>
          </div>
          <p className="text-gray-100 font-bold text-sm md:text-base text-center sm:text-left" data-id="element-316" data-mp="6zqvcmdrystq">
            🇦🇷 +500 profes de Argentina confían en <span className="text-brand-accent" data-id="element-317" data-mp="2dmze554hhnoc">Stretching 360</span>
          </p>
        </div>
      </div>
    </section>;
}